<template>
    <swb-servc-work-voucher-comn-list name="data-list" :servcType="servcType" :qryResultConfKey="qryResultConfKey" :parentPath="parentPath" :routeFilter="routeFilter" :domHeight="dataDomHeight" :id="id"></swb-servc-work-voucher-comn-list>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    //
    import SwbServcWorkVoucherComnList from './ServcWorkVoucherComnList';
    Vue.regist(SwbServcWorkVoucherComnList);
    //
    export default {
        name: 'swb-servc-work-voucher-detection-list',
        path: '/servc/work/voucher/detection/list',
        desc: '检验工单',
        helpArticleCode: 'retailer-servc-work-voucher-detection-list',
        data: function () {
            return {
                dataDomHeight: 'auto',
                //
                servcType: 6,
                qryResultConfKey: null,
                parentPath: null,
                routeFilter: {},
                id: null,
            }
        },
        created: function () {
            this.qryResultConfKey = Vue.$getClassInfo(this).name;
            this.parentPath = Vue.$getClassInfo(this).path;
            //
            let no = this.$route.query.no || null;
            this.id = this.$route.query.id || null;
            if(!Utils.isNoB(no)) {
                this.routeFilter = {
                    no: no
                };
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name = "data-list"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.dataDomHeight = height;
            });
            //domSizeWatcher.setHrEls();
            //domSizeWatcher.setVtEls(thisEl.find('.tab-container'));
            domSizeWatcher.start(500);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {}
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherDetectionList.vue